import MultiDropDown from '../../../../../../components/MultiDropDown';
import moment from 'moment';
import {
  faCheck,
  faAward,
  faUserMinus,
  faUserGraduate,
  faThumbsUp,
  faCalculator,
  faVolumeHigh,
  faVolumeSlash,
  faRetweet,
  faUpload,
  faCameraSlash,
  faClock,
  faLanguage,
  faLock,
  faMessagesQuestion,
  faChartArea,
  faShuffle,
  faEye,
  faEyeSlash,
  faCalendarDays,
  faEraser,
  faLockA,
  faAlarmExclamation,
  faTimer,
  faLockKeyhole,
  faLockKeyholeOpen,
  faShieldKeyhole,
  faPaperclip
} from '@fortawesome/pro-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/pro-light-svg-icons';
import { Form, Accordion, OverlayTrigger, Tooltip, Modal, Button } from 'react-bootstrap';
import RetakesModal from './components/retakeResultsModal';
import FloatingMenu from '../../../../../../components/floatingMenu/floatingMenu';
import {
  useUnassignStudentsMutation,
  usePushGradesMutation,
  useSetAssignmentToReviewMutation,
  useLazyGetAssignmentQuery
} from '../../../../../../features/authentication/assignmentApislice';
import HesSpinner from '../../../../../../components/loadingOverlay/hesSpinner';
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmUnassign from '../../../../../../assets/images/confirmUnassign.png';
import StudentClipboardImg from '../../../../../../assets/images/studentClipboard.png';
import CustomToast from '../../../../../../components/Toast/index';
import { useSelector } from 'react-redux';
import {
  selectFerpaState,
  selectCurrentToken
} from '../../../../../../features/authentication/authSlice';
import { useAssignmentContext } from '../../../../context';
import UiVirtualScroll from '../../../../../../components/VirtualScroll';
import ConfirmationModal from '../../../../../../../src/components/ConfirmationPopUp';
import appConfig from '../../../../../../app-config';
import StudentUploadedFilesModal from './CRGrading/components/studentUploadedFilesModal';
import { useGetClassFilterMutation, useUpdateClassFilterMutation } from '../../../../../../features/authentication/persistApiSlice';
import { useGetClassesMutation } from '../../../../../../features/authentication/authApiSlice';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { DateFormatter } from '../../../../../../utils/DateFormatter';
import ActivityTypes from '../../../../../../enums/activityTypes';
import { ActivityUtils } from '../../../../../activitySearch/activityUtils';
import { SortUtils } from '../../../../../../utils/sorting';
import { validateStudentsForReviewMode } from '../../../../../../utils/validateStudentsForReviewMode';

function AssignmentResults() {
  const studentFilesModalData = useRef(null);
  const baseUrl = appConfig.apiBaseUrl;
  const token = useSelector(selectCurrentToken);
  const [showLock, setShowLock] = useState(false);
  const [studentsSelected, setStudentsSelected] = useState(false);
  const [confirmModel, setConfirmModel] = useState(false);
  const [showRemovedStudents, setShowRemovedStudents] = useState(false);
  const [showPoints, setShowPoints] = useState(true);
  const [retryCreditId, setRetryCreditId] = useState(0);
  const [scoreUnansweredAsZero, setScoreUnansweredAsZero] = useState(false);
  const [selectedClassIds, setSelectedClassIds] = useState(null);
  const [classList, setClassList] = useState([]);
  const [displayResults, setDisplayResults] = useState([]);
  const [showRetakesModal, setShowRetakesModal] = useState(false);
  const [showConfirmUnassignModal, setShowConfirmUnassignModal] = useState(false);
  const [isAscending, setIsAscending] = useState(true);
  const [sortId, setSortId] = useState('sort-studentName');
  const navigate = useNavigate();
  const { Id, activityType = ActivityTypes.Assignment } = useParams();

  let pageNumber = 0;
  const { assignmentId, setClasses, assignmentAssignedViaDetails, assignmentName } =
    useAssignmentContext();
  const [trigger, result] = useLazyGetAssignmentQuery({
    assignmentId: Id,
    pageNumber: pageNumber,
    classIds: selectedClassIds
  });
  const [unassignStudents, unassignStudentsResult] = useUnassignStudentsMutation();
  const [pushGrades] = usePushGradesMutation();
  const [setAssignmentToReview, setAssignmentToReviewResults] = useSetAssignmentToReviewMutation();
  const ferpaEnabled = useSelector(selectFerpaState);
  const [showConfirmReviewModal, setShowConfirmReviewModal] = useState(false);
  const [setclassFilter] = useUpdateClassFilterMutation();
  const [getClassFilter] = useGetClassFilterMutation();
  const [getAllClasses] = useGetClassesMutation();
  const [showStudentFilesModal, setShowStudentFilesModal] = useState(false);
  const [currentStudentResult, setCurrentStudentResult] = useState([]);

  const [floatingMenuButtons, setFloatingMenuButtons] = useState([
    {
      id: 1,
      name: 'CR Grading',
      tooltip: `Grade CR questions for this ${ActivityUtils.getActivityName(activityType).toLowerCase()}`,
      icon: <FontAwesomeIcon icon={faAward} />,
      disabled: true,
      hide: activityType == ActivityTypes.FlashCard
    },
    {
      id: 2,
      name:  `Unassign ${ActivityUtils.getActivityName(activityType)}`,
      tooltip: `This option allows you to unassign the Original ${ActivityUtils.getActivityName(activityType)}.`,
      icon: <FontAwesomeIcon icon={faUserMinus} />,
      disabled: true
    },
    {
      id: 4,
      name: 'Set to Review Only (Includes any Retakes)',
      tooltip: 'Set to Review Only (Includes any Retakes)',
      icon: <FontAwesomeIcon icon={faThumbsUp} />,
      disabled: true,
      hide: activityType == ActivityTypes.FlashCard
    }
  ]);

  const handleClick = (floatId) => {
    switch (floatId) {
    case 1:
      handleCrGrading();
      break;
    case 2:
      setShowConfirmUnassignModal(true);
      break;
    case 3:
      handlePushGrades();
      break;
    case 4: {
      const selectedResults = displayResults.filter((item) => item.isChecked === true);
      const validationResult = validateStudentsForReviewMode(selectedResults);

      if (!validationResult.isValid) {
        CustomToast(validationResult.message, 'warning');
        return;
      }
      setShowConfirmReviewModal(true);
      break;
    }
    }
  };

  useEffect(() => {
    if(selectedClassIds)
    {
      refetch();
      setClassIdsFilter(selectedClassIds);
    }
  }, [selectedClassIds]);

  useEffect(() => {
    loadInitialData();
  },[]);

  async function loadInitialData()
  {
    var persistIds = await getClassFilter().unwrap();
    setSelectedClassIds(persistIds);

    let classes = localStorage.getItem('classes');
    if (classes) {
      classes = JSON.parse(classes);
    }else
    {
      classes = await getAllClasses().unwrap();
      localStorage.setItem('classes', JSON.stringify(classes));
    }

    setClassList([
      ...classes.map((item) => ({
        name: item.className,
        id: item.classID,
        description: item.coTeacherClass ? item.teacherName : '',
        isChecked: persistIds?.includes(item.classID)
      }))
    ]);

    setClasses([
      ...classes.map((item) => ({
        name: item.className,
        id: item.classID,
        coTeacherName: item.coTeacherClass ? item.teacherName : '',
        isChecked: persistIds?.includes(item.classID)
      }))
    ]);
  }

  const setClassIdsFilter = async (ids) => {
    try {
      await setclassFilter(ids).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (ferpaEnabled) {
      let randomSort = [...displayResults];
      randomSort.sort(() => Math.random() - 0.5);
      setDisplayResults(randomSort);
    } else {
      handleAssignmentSort(sortId, true);
    }
  }, [ferpaEnabled]);

  function refetch() {
    trigger({ assignmentId: Id, pageNumber: pageNumber, classIds: selectedClassIds }).then((response) => {
      if (!response.isSuccess || !response.data) {
        return;
      }
      setStudentsSelected(false);

      var tempArray = [...floatingMenuButtons];
      tempArray = tempArray.map((button) => {
        return button.id == 1 ? button : { ...button, disabled: true };
      });
      switch (assignmentAssignedViaDetails.id) {
      case 2:
        tempArray.splice(2, 0, {
          id: 3,
          name: 'Push Grade to Google Classroom',
          tooltip: 'Push grades to Google Classroom',
          icon: <FontAwesomeIcon icon={faGoogle} />,
          disabled: true
        });
        break;
      case 3:
      case 4:
        tempArray.splice(2, 0, {
          id: 3,
          name: `Push Grades to ${assignmentAssignedViaDetails.name}`,
          tooltip: `Push Grades to ${assignmentAssignedViaDetails.name}`,
          icon: <FontAwesomeIcon icon={faUserGraduate} />,
          disabled: true
        });
        break;
      }
      if (response.data.crGradingAvailable) {
        tempArray[0].disabled = false;
      }
      setFloatingMenuButtons(tempArray);

    });
  }

  const handleCrGrading = () => {
    navigate(`/assignments/${Id}/grade_constructiveResponses`);
  };

  async function handleSetAssignmentToReview() {
    try {
      var selectedStudentIds = displayResults
        .filter((s) => s.isChecked == true)
        .map((s) => s.studentId);
      var reviewResult = await setAssignmentToReview({
        originalAssignmentId: assignmentId,
        studentIds: selectedStudentIds
      }).unwrap();

      setShowConfirmReviewModal(false);

      if (reviewResult.students.length == selectedStudentIds.length) {
        CustomToast(reviewResult.message, 'success');
      } 
      else if(reviewResult.students.length < selectedStudentIds.length){
        CustomToast(reviewResult.message, 'warning');
      }
      refetch();
    } catch (ex) {
      CustomToast('Something went wrong trying to set assignment(s) to review', 'error');
      console.log(ex);
    }
  }

  async function handleUnassignStudents() {
    try {
      var selectedStudents = displayResults
        .filter((s) => s.isChecked == true)
        .map((s) => s.studentId);

      await unassignStudents({ assignmentId: assignmentId, studentIds: selectedStudents }).unwrap();
      setShowConfirmUnassignModal(false);
      refetch();
      CustomToast(`${selectedStudents.length} ${selectedStudents.length>1? 'Students': 'Student'} is unassigned`, 'success');
    } catch {
      CustomToast('Something went wrong when trying to unassign the students', 'error');
    }
  }

  const handlePushGrades = async () => {
    try {
      var pushGradesModel = {
        assignmentId: assignmentId,
        pushGradesToId: result?.data?.assignedVia?.id,
        scoreRetriesOptionId: retryCreditId,
        scoreUnansweredAsZero: scoreUnansweredAsZero,
        studentIds: displayResults.filter((s) => s.isChecked == true).map((s) => s.studentId)
      };

      var pushedStudents = await pushGrades(pushGradesModel).unwrap();

      if (pushedStudents.success == false) {
        if (pushedStudents.redirectUrl) {
          window.open(pushedStudents.redirectUrl, '_blank');
          CustomToast('Google login required', 'warning');
          return;
        }
        CustomToast(pushedStudents.reason, 'error');
        return;
      }

      if (pushedStudents.studentsPushed.length == pushGradesModel.studentIds.length) {
        CustomToast('All grades pushed successfully', 'success');
      } else {
        CustomToast('Not all grades were pushed', 'warning');
      }
      refetch();
    } catch (ex) {
      console.log(ex);
      CustomToast(
        `Something went wrong trying to push grades to ${result.data.assignedVia.name}`,
        'error'
      );
    }
  };

  const handleAssignmentSort = (selectedSortId, initialSort = false) => {
    setSortId(selectedSortId);
    let sortAsc = true;
    if (selectedSortId === sortId && !initialSort)
      sortAsc = !isAscending;
    setIsAscending(sortAsc);

    let sortedAssignmentResults = [...displayResults];
    switch (selectedSortId) {
    case 'sort-studentName':
      sortedAssignmentResults.sort((a, b) => {
        const nameCompare = a.studentLastName.localeCompare(b.studentLastName) ||
            a.studentFirstName.localeCompare(b.studentFirstName);
        return sortAsc ? nameCompare : -nameCompare;
      });
      break;
    case 'sort-className':
      sortedAssignmentResults = SortUtils.customSort(sortedAssignmentResults, 'className', sortAsc);
      break;
    case 'sort-crAnsweredCount':
      sortedAssignmentResults = SortUtils.customSort(sortedAssignmentResults, 'crAnsweredCount', sortAsc);
      break;
    case 'sort-rawScore':
      switch (retryCreditId) {
      case 0:
        if (showPoints) {
          sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
            sortAsc ? (a.retriesAsNoCreditScore?.point > b.retriesAsNoCreditScore?.point ? 1 : -1)
              : (a.retriesAsNoCreditScore?.point < b.retriesAsNoCreditScore?.point ? 1 : -1)
          );
        } else {
          if (scoreUnansweredAsZero) {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              sortAsc ? (a.retriesAsNoCreditScore?.percentUnansweredAsZero >
                    b.retriesAsNoCreditScore?.percentUnansweredAsZero ? 1 : -1)
                : (a.retriesAsNoCreditScore?.percentUnansweredAsZero <
                      b.retriesAsNoCreditScore?.percentUnansweredAsZero ? 1 : -1)
            );
          } else {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              sortAsc ? (a.retriesAsNoCreditScore?.percent > b.retriesAsNoCreditScore?.percent ? 1 : -1)
                : (a.retriesAsNoCreditScore?.percent < b.retriesAsNoCreditScore?.percent ? 1 : -1)
            );
          }
        }
        break;
      case 1:
        if (showPoints) {
          sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
            sortAsc ? (a.retriesAsHalfCreditScore?.point > b.retriesAsHalfCreditScore?.point ? 1 : -1)
              : (a.retriesAsHalfCreditScore?.point < b.retriesAsHalfCreditScore?.point ? 1 : -1)
          );
        } else {
          if (scoreUnansweredAsZero) {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              sortAsc ? (a.retriesAsHalfCreditScore?.percentUnansweredAsZero >
                    b.retriesAsHalfCreditScore?.percentUnansweredAsZero ? 1 : -1)
                : (a.retriesAsHalfCreditScore?.percentUnansweredAsZero <
                      b.retriesAsHalfCreditScore?.percentUnansweredAsZero ? 1 : -1)
            );
          } else {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              sortAsc ? (a.retriesAsHalfCreditScore?.percent > b.retriesAsHalfCreditScore?.percent ? 1 : -1)
                : (a.retriesAsHalfCreditScore?.percent < b.retriesAsHalfCreditScore?.percent ? 1 : -1)
            );
          }
        }
        break;
      case 2:
        if (showPoints) {
          sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
            sortAsc ? (a.retriesAsFullCreditScore?.point > b.retriesAsFullCreditScore?.point ? 1 : -1)
              : (a.retriesAsFullCreditScore?.point < b.retriesAsFullCreditScore?.point ? 1 : -1)
          );
        } else {
          if (scoreUnansweredAsZero) {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              sortAsc ? (a.retriesAsFullCreditScore?.percentUnansweredAsZero >
                    b.retriesAsFullCreditScore?.percentUnansweredAsZero ? 1 : -1)
                : (a.retriesAsFullCreditScore?.percentUnansweredAsZero <
                      b.retriesAsFullCreditScore?.percentUnansweredAsZero ? 1 : -1)
            );
          } else {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              sortAsc ? (a.retriesAsFullCreditScore?.percent > b.retriesAsFullCreditScore?.percent ? 1 : -1)
                : (a.retriesAsFullCreditScore?.percent < b.retriesAsFullCreditScore?.percent ? 1 : -1)
            );
          }
        }
        break;
      default:
        if (showPoints) {
          sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
            sortAsc ? (a.retriesAsNoCreditScore?.point > b.retriesAsNoCreditScore?.point ? 1 : -1)
              : (a.retriesAsNoCreditScore?.point < b.retriesAsNoCreditScore?.point ? 1 : -1)
          );
        } else {
          if (scoreUnansweredAsZero) {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              sortAsc ? (a.retriesAsNoCreditScore?.percentUnansweredAsZero >
                    b.retriesAsNoCreditScore?.percentUnansweredAsZero ? 1 : -1)
                : (a.retriesAsNoCreditScore?.percentUnansweredAsZero <
                      b.retriesAsNoCreditScore?.percentUnansweredAsZero ? 1 : -1)
            );
          } else {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              sortAsc ? (a.retriesAsNoCreditScore?.percent > b.retriesAsNoCreditScore?.percent ? 1 : -1)
                : (a.retriesAsNoCreditScore?.percent < b.retriesAsNoCreditScore?.percent ? 1 : -1)
            );
          }
        }
      }
      break;
    case 'sort-retakeBestScore':
      sortedAssignmentResults = SortUtils.customSort(sortedAssignmentResults, 'masteryScore', sortAsc);
      break;
    case 'sort-dateAssigned':
      sortedAssignmentResults = SortUtils.customSort(sortedAssignmentResults, 'dateAssigned', sortAsc);
      break;
    case 'sort-dateStarted':
      sortedAssignmentResults = SortUtils.customSort(sortedAssignmentResults, 'dateStarted', sortAsc);
      break;
    case 'sort-completedDate':
      sortedAssignmentResults = SortUtils.customSort(sortedAssignmentResults, 'completedDate', sortAsc);
      break;
    case 'sort-lock':
      sortedAssignmentResults.sort((a, b) =>
        sortAsc ? a.assignmentOptions.locked - b.assignmentOptions.locked
          : b.assignmentOptions.locked - a.assignmentOptions.locked
      );
      break;
    case 'sort-status':
      sortedAssignmentResults = SortUtils.customSort(sortedAssignmentResults, 'status', sortAsc);
      break;
    }

    setDisplayResults(sortedAssignmentResults);
  };

  const handleAssignmentChecked = (e) => {
    const { name, checked } = e.target;
    let tempAssignmentResults = [...displayResults];

    if (name === 'allselect') {
      tempAssignmentResults = tempAssignmentResults.map((item) => {
        return { ...item, isChecked: checked };
      });
    } else {
      tempAssignmentResults = tempAssignmentResults.map((item) =>
        item.studentId == name ? { ...item, isChecked: checked } : item
      );
    }
    setDisplayResults(tempAssignmentResults);
    let tempButtons = [...floatingMenuButtons];
    const noStudentSelected = tempAssignmentResults.filter((s) => s.isChecked == true).length == 0;
    setStudentsSelected(!noStudentSelected);
    tempButtons = tempButtons.map((button) => {
      if (button.id === 1) return button;

      if (button.id === 4) {
        return {
          ...button,
          disabled: noStudentSelected || !result?.data?.retakeEnabled
        };
      }

      return { ...button, disabled: noStudentSelected };
    });
    setFloatingMenuButtons(tempButtons);
  };

  const handleClassSelectionChange = (e) => {
    const { key } = e;
    const selected = key !== '000' ? classList.find((v) => v.id == key) : classList;
    let tempValue = [];

    if (key === '000') {
      tempValue = classList.map((item) => ({
        ...item,
        isChecked: !classList.filter((item) => item?.isChecked !== true).length < 1
      }));
    } else {
      tempValue = classList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setClassList(tempValue);
    const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
    setSelectedClassIds(ids);
    let tempButtons = [...floatingMenuButtons];
    const noStudentSelected =
      displayResults.filter((item) => ids.includes(item.classId) && item.isChecked == true)
        .length == 0;
    tempButtons = tempButtons.map((button) => {
      if (button.id == 1) return button;
      if (button.id === 4) {
        return {
          ...button,
          disabled: noStudentSelected || !result?.data?.retakeEnabled
        };
      }
      return { ...button, disabled: noStudentSelected };
    });
    setFloatingMenuButtons(tempButtons);
  };

  useEffect(() => {
    if (!result.data)
    {
      setDisplayResults([]);
      return;
    }
    setDisplayResults(
      result.data.assignmentResults.map(item => {
        const allScores = getScores(item, showPoints);
        const status = item.dateCompleted?.length ? 'Completed' : 'Incomplete';
        return {
          ...item,
          displayScore: allScores.displayScore,
          score: allScores.score,
          scorePercentage: allScores.scorePercentage,
          accumulatedRetake: allScores.accumulatedScore,
          accumulatedScorePercentage: allScores.accumulatedScorePercentage,
          studentName: `${item.studentLastName} ${item.studentFirstName}`,
          status: status,
          dateAssigned: item.dateAssigned
            ? new Intl.DateTimeFormat('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            })
              .format(new Date(item.dateAssigned))
              .replace(/\//g, '-')
            : '',

          dateStarted: item.dateStarted
            ? DateFormatter.toLongDateTime(item.dateStarted)
            : '',

          completedDate: item.dateCompleted
            ? new Intl.DateTimeFormat('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            })
              .format(new Date(item.dateCompleted))
              .replace(/\//g, '-')
            : item.timedOut
              ? 'Timed Out!'
              : item.pastDue
                ? 'Past Due!'
                : ''
        };
      })
    );

    if (
      displayResults.length == 0 ||
      displayResults.filter((item) => selectedClassIds.includes(item.classId)).length == 0 ||
      (!showRemovedStudents && displayResults.filter((item) => !item.isRemoved).length == 0)
    ) {
      setShowLock(false);
    } else {
      setShowLock(true);
    }
  }, [result.data,retryCreditId,scoreUnansweredAsZero,showPoints]);

  const reportNavigateHandler = (studentId, assignmentId, name, scoreUnansweredAsZero) => {
    navigate(`/assignments/${Id}/${activityType}/manage_assign/reports/student_session_report?studentId=${studentId}&incompleteScoring=${scoreUnansweredAsZero}`, {
      state: { className: name }
    });
  };

  const lockStudents = () => {
    !studentsSelected
      ? CustomToast('Please check at least one student.', 'info')
      : setConfirmModel(true);
  };

  const updateSelectedStudentLock = async () => {
    var selectedStudents = displayResults
      .filter((s) => s.isChecked == true)
      .map((s) => s.studentId);
    updateLockedStatus(selectedStudents);
  };

  const updateIndividualStudentLock = (studentId) => {
    updateLockedStatus([studentId]);
  };

  const updateLockedStatus = async (selectedStudents) => {
    let url = baseUrl + `/Assignment/${assignmentId}/LockStatus`;
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    const lockedResponse = await fetch(url, {
      headers,
      method: 'PUT',
      credentials: 'include',
      body: JSON.stringify(selectedStudents)
    });
    if (lockedResponse.status == 200) {
      refetch();
      setConfirmModel(false);
      CustomToast(`${ActivityUtils.getActivityName(activityType)} Mode Changed Successfully`, 'success');
    } else {
      const errorMsg = await lockedResponse.text();
      CustomToast(`${errorMsg}`, 'error');
      setConfirmModel(false);
    }
  };

  function generateAssignmentDetails(assignmentOptions, index, optionsPerRow) {
    let assignmentDetails = [];

    switch (assignmentOptions.mode) {
    case 0:
    case 4:
    case 6:
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
                Mode: Open
            </Tooltip>
          }>
          <div
            className="assignmentOptions"
            style={{ color: '#48E0B2', backgroundColor: '#E3FFF6' }}>
              Open
          </div>
        </OverlayTrigger>
      );
      break;
    case 2:
    case 7:
    case 8:
    case 9:
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
                Mode: Quiz
            </Tooltip>
          }>
          <div
            className="assignmentOptions"
            style={{ color: '#A29BFE', backgroundColor: '#E9E9FD' }}>
              Quiz
          </div>
        </OverlayTrigger>
      );
      break;
    case 1:
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
                Mode: Locked
            </Tooltip>
          }>
          <div
            className="assignmentOptions"
            style={{ color: '#F84646', backgroundColor: '#FFE3E3' }}>
              Locked
          </div>
        </OverlayTrigger>
      );
      break;
    case 3:
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
                Mode: Review
            </Tooltip>
          }>
          <div
            className="assignmentOptions"
            style={{ color: '#FFA800', backgroundColor: '#FFF4E3', fontSize: '1em' }}>
              Review
          </div>
        </OverlayTrigger>
      );
      break;
    case 5:
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
                Mode: Offline
            </Tooltip>
          }>
          <div
            className="assignmentOptions"
            style={{ color: '#525252', backgroundColor: '#F0F2F8' }}>
              Offline
          </div>
        </OverlayTrigger>
      );
      break;
    case 11:
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
                Mode: GradeCam
            </Tooltip>
          }>
          <div
            className="assignmentOptions"
            style={{ color: '#82A9E2', backgroundColor: '#E4EFFC' }}>
              GradeCam
          </div>
        </OverlayTrigger>
      );
      break;
    }

    switch (assignmentOptions.mode) {
    case 2:
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentModeOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
                Show grade upon completion of quiz
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#E3FFF6' }}>
            <FontAwesomeIcon icon={faEye} color="#48E0B2" />
          </div>
        </OverlayTrigger>
      );
      break;
    case 6:
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentModeOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
                Automatically lock questions
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
            <FontAwesomeIcon icon={faLockA} color="#F84646" />
          </div>
        </OverlayTrigger>
      );
      break;
    case 8:
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentModeOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
                Allow changes to answers
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#FFF2F7' }}>
            <FontAwesomeIcon icon={faEraser} color="#FD79A8" />
          </div>
        </OverlayTrigger>
      );
      break;
    case 9:
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentModeOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
              {'Don\'t show grade upon completion of quiz'}
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
            <FontAwesomeIcon icon={faEyeSlash} color="#F84646" />
          </div>
        </OverlayTrigger>
      );
      break;
    }

    // Past Due
    if (assignmentOptions.timedOut)
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentTimedOut-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentTimedOut-${index}`} className="custom-tooltip">
              Past due
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
            <FontAwesomeIcon icon={faAlarmExclamation} color="#F84646" />
          </div>
        </OverlayTrigger>
      );

    // From/To
    if (assignmentOptions.mode == 4 || assignmentOptions.availability) {
      var dateTimeOptions = {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
        hour: 'numeric',
        minute: '2-digit'
      };
      assignmentDetails.push(
        <OverlayTrigger
          key={`assignmentTimedOut-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-assignmentTimedOut-${index}`} className="custom-tooltip">
              From/To
              <br />
              {`${new Date(assignmentOptions.availability?.startDate).toLocaleString(
                'en-US',
                dateTimeOptions
              )} - ${new Date(assignmentOptions.availability?.endDate).toLocaleString(
                'en-US',
                dateTimeOptions
              )}`}
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#D9F6FF' }}>
            <FontAwesomeIcon icon={faCalendarDays} color="#09BCF3" />
          </div>
        </OverlayTrigger>
      );
    }

    // Timed
    if (assignmentOptions.timeLimit) {
      var duration = moment.duration(assignmentOptions.timeLimit);
      assignmentDetails.push(
        <OverlayTrigger
          key={`timed-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-timedOption-${index}`} className="custom-tooltip">
              {ActivityUtils.getActivityName(activityType)} is timed:{' '}
              {`${duration.hours() > 0 ? duration.hours() + 'h' : ''} ${duration.minutes()}m`}
            </Tooltip>
          }>
          <div className="assignmentOptions assignmentOptionsIcon">
            <FontAwesomeIcon color="#82A9E2" icon={faTimer} />
          </div>
        </OverlayTrigger>
      );
    }

    // On screen calculator
    if (assignmentOptions.onScreenCalculator)
      if (assignmentOptions.calculatorType === 1) {
        assignmentDetails.push(
          <OverlayTrigger
            key={`calculatorOption-${index}`}
            placement="top"
            overlay={
              <Tooltip id={`tooltip-calculatorOption-${index}`} className="custom-tooltip">
                A 4 Function Calculator is available on screen for this {ActivityUtils.getActivityName(activityType).toLowerCase()}
              </Tooltip>
            }>
            <div className="assignmentOptions" style={{ backgroundColor: 'lightpink' }}>
              <FontAwesomeIcon color="red" icon={faCalculator} />
            </div>
          </OverlayTrigger>
        );
      } else if (assignmentOptions.calculatorType === 2) {
        assignmentDetails.push(
          <OverlayTrigger
            key={`calculatorOption-${index}`}
            placement="top"
            overlay={
              <Tooltip id={`tooltip-calculatorOption-${index}`} className="custom-tooltip">
                A Scientific Calculator is available on screen for this {ActivityUtils.getActivityName(activityType).toLowerCase()}
              </Tooltip>
            }>
            <div className="assignmentOptions" style={{ backgroundColor: '#E4EFFC' }}>
              <FontAwesomeIcon color="#82A9E2" icon={faCalculator} />
            </div>
          </OverlayTrigger>
        );
      }

    if (assignmentOptions.questionsRandomized)
      assignmentDetails.push(
        <OverlayTrigger
          key={`randomizedOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-randomizedOption-${index}`} className="custom-tooltip">
              Questions are Randomized
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#FFF2F7' }}>
            <FontAwesomeIcon color="#FD79A8" icon={faShuffle} />
          </div>
        </OverlayTrigger>
      );

    if (assignmentOptions.retakes)
      assignmentDetails.push(
        <OverlayTrigger
          key={`retakeOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-retakeOption-${index}`} className="custom-tooltip">
              Retakes Enabled
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#F2E5FF' }}>
            <FontAwesomeIcon icon={faRetweet} color="#9E5CDF" />
          </div>
        </OverlayTrigger>
      );

    if (assignmentOptions.textToSpeech) {
      assignmentDetails.push(
        <OverlayTrigger
          key={`textToSpeechOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-textToSpeechOption-${index}`} className="custom-tooltip">
              Text-to-Speech Enabled
            </Tooltip>
          }>
          <div className='assignmentOptions bg-lightgreen'>
            <FontAwesomeIcon icon={faVolumeHigh} className='success-icon-btn' />
          </div>
        </OverlayTrigger>
      );
    } else {
      assignmentDetails.push(
        <OverlayTrigger
          key={`textToSpeechOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-textToSpeechOption-${index}`} className="custom-tooltip">
              Text-to-Speech Disabled
            </Tooltip>
          }>
          <div className='assignmentOptions bg-lightred'>
            <FontAwesomeIcon icon={faVolumeSlash} className='danger-icon-btn' />
          </div>
        </OverlayTrigger>
      );
    }

    if (assignmentOptions.timeOnTask)
      assignmentDetails.push(
        <OverlayTrigger
          key={`timeOnTaskOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-timeOnTaskOption-${index}`} className="custom-tooltip">
              The amount of time the student takes answering questions will be tracked
              <br />
              {`Maximum Time Per Question: ${assignmentOptions.timeOnTask}`}
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#D9F6FF' }}>
            <FontAwesomeIcon icon={faClock} color="#09BCF3" />
          </div>
        </OverlayTrigger>
      );

    if (assignmentOptions.photomathBlocker)
      assignmentDetails.push(
        <OverlayTrigger
          key={`photomathBlockerOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-photomathBlockerOption-${index}`} className="custom-tooltip">
              Photomath Blocker Enabled
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
            <FontAwesomeIcon icon={faCameraSlash} color="#F84646" />
          </div>
        </OverlayTrigger>
      );

    if (assignmentOptions.allowLanguageChange)
      assignmentDetails.push(
        <OverlayTrigger
          key={`languageChangeOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-languageChangeOption-${index}`} className="custom-tooltip">
              The student will be allowed to change the display language while taking this {ActivityUtils.getActivityName(activityType).toLowerCase()}.
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#E3FFF6' }}>
            <FontAwesomeIcon icon={faLanguage} color="#48E0B2" />
          </div>
        </OverlayTrigger>
      );

    if (assignmentOptions.browserLockdown)
      assignmentDetails.push(
        <OverlayTrigger
          key={`browserLockOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-browserLockOption-${index}`} className="custom-tooltip">
              The student will not be allowed have other browser tabs or windows open while taking
              this {ActivityUtils.getActivityName(activityType).toLowerCase()}.
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
            <FontAwesomeIcon icon={faLock} color="#F84646" />
          </div>
        </OverlayTrigger>
      );

    if (assignmentOptions.studentUploadFiles)
      assignmentDetails.push(
        <OverlayTrigger
          key={`studentFileUploadOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-studentFileUploadOption-${index}`} className="custom-tooltip">
              Student is allowed to upload files
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#E4EFFC' }}>
            <FontAwesomeIcon icon={faUpload} color="#82A9E2" />
          </div>
        </OverlayTrigger>
      );
    if (assignmentOptions.locked)
      assignmentDetails.push(
        <OverlayTrigger
          key={`locked-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-studentFileUploadOption-${index}`} className="custom-tooltip">
              Locked
            </Tooltip>
          }>
          <div className="assignmentOptions assignmentOptionsIcon">
            <FontAwesomeIcon icon={faUpload} color="#82A9E2" />
          </div>
        </OverlayTrigger>
      );

    let detailRows = [];
    var keyIndex = 0;
    do {
      detailRows.push(
        <div
          key={`optionRow${index}${keyIndex}`}
          className={`d-flex flex-row ${keyIndex > 0 ? 'mt-2' : ''}`}>
          {assignmentDetails.splice(0, optionsPerRow).map((assignmentOption) => {
            return assignmentOption;
          })}
        </div>
      );
      keyIndex++;
    } while (assignmentDetails.length > 0);

    return <div className="d-flex flex-column mb-3 mt-3 mx-3 align-items-center">{detailRows}</div>;
  }

  const calculateOriginalScore = (item,showPoints) => {
    let originalScore = 0;
    let scorePercentage = '0%';
    let displayScore = '';
    let answeredCount = item.correctCount + item.incorrectCount + item.correctOnRetryCount + item.crAnsweredCount;
    let unAnsweredCount = item.totalQuestionCount - answeredCount;
    let answeredCountWithCRPoint = item.correctCount + (scoreUnansweredAsZero? (item.incorrectCount + getUnansweredCount_ExceptCr(item)):item.incorrectCount) + item.correctOnRetryCount + item.maxCRPoint;

    if(!scoreUnansweredAsZero && answeredCount == 0 && !item.dateStarted){
      displayScore = 'Not Started';
    }
    else if(!scoreUnansweredAsZero && answeredCount == 0 && item.dateStarted){
      displayScore = 'None Answered';
    }
    else if(!scoreUnansweredAsZero && unAnsweredCount>0 || item.crPoint == -1)
    {
      displayScore = 'Incomplete';
    }
    else if(!scoreUnansweredAsZero && (item.crPoint == 127 || item.crPoint == -2 || item.crPoint == null)){
      displayScore = 'Not Scored';
    }
    else{
      switch (retryCreditId) {
      case 1:
        displayScore=originalScore = item.correctCount + item.correctOnRetryCount/2 + item.crPoint ; 
        displayScore=scorePercentage = Math.round((originalScore / answeredCountWithCRPoint) * 100)+'%';
        break;
      case 2:
        displayScore=originalScore = item.correctCount + item.correctOnRetryCount + item.crPoint ;
        displayScore=scorePercentage = Math.round((originalScore / answeredCountWithCRPoint) * 100)+'%';
        break;
      default:
        displayScore=originalScore = item.correctCount + item.crPoint ;
        displayScore=scorePercentage = Math.round((originalScore / answeredCountWithCRPoint) * 100)+'%';
        break;
      }
      displayScore = showPoints ? originalScore : scorePercentage;
    }
    return {displayScore: displayScore, score: originalScore, answeredCount: answeredCountWithCRPoint, scorePercentage: scorePercentage};          
  };

  const getUnansweredCount_ExceptCr = (item) => {
    let answeredCount = item.correctCount + item.incorrectCount + item.correctOnRetryCount + item.crQuestionCount;
    let unAnsweredCount = item.totalQuestionCount - answeredCount;
    return unAnsweredCount;
  };

  const getScores = (item,showPoints) => {
    let originalScore = calculateOriginalScore(item,showPoints);
    let accumulatedScore;
    let accumulatedAnsweredCount = originalScore.answeredCount;
    let accumulatedScorePercentage;

    if(item.retakeResults && item.retakeResults.length > 0)
    {
      accumulatedScore = originalScore.score;
      item.retakeResults.map((retake) => {
        let retakeScore = calculateOriginalScore(retake,showPoints);
        accumulatedScore += retakeScore.score;
        accumulatedAnsweredCount += retakeScore.answeredCount;
      });
      accumulatedScorePercentage = accumulatedAnsweredCount > 0
        ? Math.round((accumulatedScore / accumulatedAnsweredCount) * 100) + '%'
        : 'N/A';
    } else {
      accumulatedScore = 'N/A';
      accumulatedScorePercentage = 'N/A';
    }
    return { accumulatedScore: accumulatedScore ,
      accumulatedScorePercentage: accumulatedScorePercentage,
      displayScore: originalScore.displayScore,
      score: originalScore.score,
      scorePercentage: originalScore.scorePercentage};
  };

  const handleRetakeResultsClick = async (studentResult) => {
    setShowRetakesModal(true);
    setCurrentStudentResult({ ...studentResult});
  };

  const sortButtons = (currentSortId) => {
    return <button className="sort-btn-simple row">
      <FontAwesomeIcon icon={faCaretUp} className={`p-0 ${sortId === currentSortId && isAscending ? '' : 'text-grey'}`} />
      <FontAwesomeIcon icon={faCaretDown} className={`p-0 align-caret-down ${sortId === currentSortId && !isAscending ? '' : 'text-grey'}`} />
    </button>;
  };

  return (
    <>
      <StudentUploadedFilesModal
        studentFilesData={studentFilesModalData.current}
        assignmentName={assignmentName}
        show={showStudentFilesModal}
        onHide={() => setShowStudentFilesModal(false)}
        isFerpa={!ferpaEnabled}
      />
      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={() => updateSelectedStudentLock()}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          `This would LOCK selected student ${ActivityUtils.getActivityName(activityType).toLowerCase()} that is unlocked and UNLOCK selected student ${ActivityUtils.getActivityName(activityType).toLowerCase()} that is locked. Are you sure want to continue?`
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <div className="d-flex flex-row align-items-center">
        <Form.Group className="w-25" style={{ marginRight: '0.5vw' }}>
          <Form.Label htmlFor="classDropdown">Class</Form.Label>

          <MultiDropDown
            value={classList}
            setValue={setClassList}
            dropdownId="classesFilter"
            placeholder="Filter Classes"
            handleChange={(e) => handleClassSelectionChange(e)}
            selectedId={selectedClassIds}
            setSelectedId={setSelectedClassIds}
            description={true}
            selectAllText="All Classes"
            coteachertext={true}
          />
        </Form.Group>
        <div className="w-100" style={{ marginTop: '35px' }}>
          <Form.Check
            type="checkbox"
            id="displayRemovedStudents"
            className="d-flex flex-row align-items-center">
            <Form.Check.Input
              type="checkbox"
              defaultChecked={showRemovedStudents}
              checked={showRemovedStudents}
              style={{ marginRight: '5px' }}
              onChange={() => setShowRemovedStudents(!showRemovedStudents)}
            />
            <Form.Check.Label>Display Removed Students</Form.Check.Label>
          </Form.Check>
        </div>
      </div>

      {activityType != ActivityTypes.FlashCard && <Accordion className="d-flex flex-row mt-4 accordion-castleShaded " defaultActiveKey="0">
        <Accordion.Item className="w-100" eventKey="0">
          <Accordion.Header>
            <h1 style={{ margin: '0px' }} className="text-color">
              Score Options
            </h1>
          </Accordion.Header>
          <Accordion.Body className="d-flex flex-column">
            <div className="d-flex flex-row">
              <div className="d-flex flex-column">
                <Form.Label
                  style={{ fontSize: '14px', fontWeight: '500' }}
                  className="text-color"
                  htmlFor="scoreAsRadio">
                  Show score as
                </Form.Label>
                <Form.Group id="scoreAsRadio">
                  <Form.Check
                    inline
                    label="Points"
                    name="scoreGroup"
                    type="radio"
                    id="pointsRadio"
                    defaultChecked="true"
                    onChange={() => setShowPoints(true)}
                  />
                  <Form.Check
                    inline
                    label="Percent"
                    name="scoreGroup"
                    type="radio"
                    id="percentRadio"
                    onChange={() => setShowPoints(false)}
                  />
                </Form.Group>
              </div>

              <div className="d-flex flex-column mx-3">
                <Form.Label
                  style={{ fontSize: '14px', fontWeight: '500' }}
                  className="text-color"
                  htmlFor="retriesRadio">
                  Retries
                </Form.Label>
                <Form.Group id="retriesRadio">
                  <Form.Check
                    inline
                    label="Score with retries as no credit"
                    name="retriesGroup"
                    type="radio"
                    id="noCreditRadio"
                    defaultChecked="true"
                    onChange={() => setRetryCreditId(0)}
                  />
                  <Form.Check
                    inline
                    label="Score with retries as half credit"
                    name="retriesGroup"
                    type="radio"
                    id="halfCreditRadio"
                    onChange={() => setRetryCreditId(1)}
                  />
                  <Form.Check
                    inline
                    label="Score with retries as full credit"
                    name="retriesGroup"
                    type="radio"
                    id="fullCreditRadio"
                    onChange={() => setRetryCreditId(2)}
                  />
                </Form.Group>
              </div>
            </div>

            <Form.Check
              className="mt-3"
              type="checkbox"
              id="scoreUnansweredQuestions"
              label="Score unanswered short answer questions as Incorrect and unscored/unanswered CR questions as 0 points"
              defaultChecked={false}
              onChange={() => setScoreUnansweredAsZero(!scoreUnansweredAsZero)}
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      }
      <div className="d-flex flex-row mt-5 mb-4 justify-content-between">
        <h1>
          {ActivityUtils.getActivityName(activityType)} Results
        </h1>
        <div className="d-flex flex-row">
          {showLock && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="modal-title-tooltip">
                  Select a student/students to lock or
                  <br /> unlock their {ActivityUtils.getActivityName(activityType).toLowerCase()}.
                </Tooltip>
              }>
              <button
                className="lockIcon btn-link primary-link px-3"
                onClick={() => {
                  lockStudents();
                }}>
                <FontAwesomeIcon icon={faShieldKeyhole} className="lockUnlock" /> Lock/Unlock
              </button>
            </OverlayTrigger>
          )}
          <span>
            Number of {activityType != ActivityTypes.FlashCard ? 'questions' : 'vocabularies'} in the {ActivityUtils.getActivityName(activityType).toLowerCase()}
            <span className="assignQuestionsCount">{result?.data?.questionsCount}</span>
          </span>
          <span className="ms-3">
            Number of students assigned
            <span className="assignQuestionsCount">
              {result?.data?.totalAssignedStudents}
            </span>
          </span>
        </div>
      </div>
      <div className="custom-table table-aligned">
        <UiVirtualScroll rowHeight={60} height="400px">
          <table className="table">
            <thead>
              <tr>
                <th className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    value=""
                    id="flexCheckDefault"
                    name="allselect"
                    checked={
                      displayResults.length == 0
                        ? false
                        : displayResults?.filter((item) => item?.isChecked !== true).length < 1
                    }
                    onChange={handleAssignmentChecked}
                    defaultChecked={false}
                  />
                </th>
                <th onClick={()=> handleAssignmentSort('sort-studentName')}>
                  <div className='align-items-center d-flex gap-2'>
                    <div>Student Name</div>
                    {sortButtons('sort-studentName')}
                  </div>
                </th>
                <th onClick={()=> handleAssignmentSort('sort-className')}>
                  <div className='align-items-center d-flex gap-2 justify-content-center'>
                    <div>Class</div>
                    {sortButtons('sort-className')}
                  </div>
                </th>
                <th className="text-center text-pre" onClick={()=> handleAssignmentSort('sort-dateAssigned')}>
                  <div className='align-items-center d-flex gap-2 justify-content-center'>
                    <div>Date<br />Assigned</div>
                    {sortButtons('sort-dateAssigned')}
                  </div>
                </th>
                {activityType != ActivityTypes.FlashCard &&(
                  <>
                    <th>
                      <FontAwesomeIcon icon={faCheck} />
                    </th>
                    <th>
                      <FontAwesomeIcon icon={faX} />
                    </th>
                    {activityType == ActivityTypes.Assignment && <th>
                      <FontAwesomeIcon icon={faX} />
                      <FontAwesomeIcon icon={faCheck} />
                    </th>
                    }
                    <th className="text-center text-pre" onClick={()=> handleAssignmentSort('sort-crAnsweredCount')}>
                      <div className='align-items-center d-flex gap-2 justify-content-center'>
                        CR<br />Answered{' '}
                        {sortButtons('sort-crAnsweredCount')}
                      </div>
                    </th>
                    <th className="text-center text-pre" onClick={()=> handleAssignmentSort('sort-rawScore')}>
                      <div className='align-items-center d-flex gap-2 justify-content-center'>
                        Original
                        <br />
                        Score{' '}
                        {sortButtons('sort-rawScore')}
                      </div>
                    </th>
                    {activityType == ActivityTypes.Assignment && <th className="text-center text-pre" onClick={()=> handleAssignmentSort('sort-retakeBestScore')}>
                      <div className='align-items-center d-flex gap-2 justify-content-center'>
                        Accumulated
                        <br />
                        Retake Score
                        {sortButtons('sort-retakeBestScore')}
                      </div>
                    </th>
                    }


                    <th className="text-center text-pre" onClick={()=> handleAssignmentSort('sort-dateStarted')}>
                      <div className='align-items-center d-flex gap-2 justify-content-center'>
                        Date
                        <br />
                        Started{' '}
                        {sortButtons('sort-dateStarted')}
                      </div>
                    </th>
                  </>
                )}
                <th className="text-center text-pre" onClick={()=> handleAssignmentSort('sort-completedDate')}>
                  <div className='align-items-center d-flex gap-2 justify-content-center'>
                    Date
                    <br />
                    Completed{' '}
                    {sortButtons('sort-completedDate')}
                  </div>
                </th>
                {activityType == ActivityTypes.Assignment && <th className="text-center text-pre">
                  Retakes
                  <br />
                  Issued
                </th>
                }
                {activityType != ActivityTypes.FlashCard &&(
                  <>
                    <th className="text-center text-pre" onClick={()=> handleAssignmentSort('sort-lock')}>
                      <div className='align-items-center d-flex gap-2 justify-content-center'>
                        Lock
                        {sortButtons('sort-lock')}
                      </div>
                    </th>
                  </>
                )}
                {activityType == ActivityTypes.FlashCard &&(
                  <>
                    <th className="text-center text-pre" onClick={()=> handleAssignmentSort('sort-status')}>
                      <div className='align-items-center d-flex gap-2 justify-content-center'>
                        Status
                        {sortButtons('sort-status')}
                      </div>
                    </th>
                  </>
                )}
                <th className="text-center text-pre">
                  Details
                </th>
                {activityType != ActivityTypes.FlashCard &&(
                  <th></th>
                )}
              </tr>
            </thead>
            <tbody>
              {result.isError && (
                <tr>
                  <td colSpan="16" style={{ textAlign: 'center' }}>
                    <button
                      style={{
                        color: '#F84646',
                        fontSize: '1.15rem',
                        border: 'none',
                        background: 'none'
                      }}
                      onClick={() => refetch()}>
                      There was an error getting the data. Click to try again
                    </button>
                  </td>
                </tr>
              )}
              {result.isFetching && (
                <tr>
                  <td colSpan="15">
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: '40px' }}>
                      <HesSpinner />
                      <span className="ms-3">Loading results...</span>
                    </div>
                  </td>
                </tr>
              )}
              {!result.isFetching &&
                result.isSuccess &&
                (result?.data?.totalAssignedStudents == 0 || displayResults.length == 0 ||
                  (!showRemovedStudents &&
                    displayResults.filter((item) => !item.isRemoved).length == 0)) && (
                <tr>
                  <td colSpan="16">
                    <div
                      className="d-flex align-items-end justify-content-center text-align-center"
                      style={{
                        backgroundImage: `url(${StudentClipboardImg})`,
                        backgroundRepeat: 'no-repeat',
                        height: '130px',
                        backgroundPositionX: 'center'
                      }}>
                      {
                        result?.data?.totalAssignedStudents == 0 ?
                          <span>There are no students assigned to this {ActivityUtils.getActivityName(activityType).toLowerCase()}</span>
                          :
                          (displayResults.length == 0 ||
                              (!showRemovedStudents && displayResults.filter((item) => !item.isRemoved).length == 0)) && (
                            <span>There are no available students within the selected classes</span>
                          )}
                    </div>
                  </td>
                </tr>
              )}

              {!result.isFetching && displayResults &&
                displayResults.map((item, index) => {
                  if (!showRemovedStudents && item.isRemoved)
                    return;

                  return (
                    <tr key={`assignmentResult_${index}`}>
                      <td className='text-center'>
                        {' '}
                        <input
                          type="checkbox"
                          value=""
                          name={item.studentId}
                          checked={item?.isChecked || false}
                          onChange={handleAssignmentChecked}
                          className="form-check-input"
                          id={`flexCheckDefault${item.assignmentId}`}
                        />
                      </td>
                      <td className='text-break min-w-150 max-w-150'>{ferpaEnabled ? item.studentName : 'hidden'}</td>
                      <td className='text-center text-break min-max-w-100'>{item.className}</td>
                      <td className="text-center text-nowrap">
                        {item.dateAssigned}
                      </td>
                      {activityType != ActivityTypes.FlashCard && (
                        <>
                          <td className="text-center">{item.correctCount}</td>
                          <td className="text-center">{scoreUnansweredAsZero? (item.incorrectCount + getUnansweredCount_ExceptCr(item)):item.incorrectCount}</td>
                          {activityType == ActivityTypes.Assignment && <td className="text-center">{item.correctOnRetryCount}</td>}
                          <td className="text-center">{scoreUnansweredAsZero? item.crQuestionCount: item.crAnsweredCount}</td>
                          <td className="text-center">{item.displayScore}</td>
                          {activityType == ActivityTypes.Assignment && <td className="text-center">{showPoints? item.accumulatedRetake : item.accumulatedScorePercentage}</td>}
                          <td className="text-center">
                            {item.dateStarted}
                          </td>
                        </>
                      )}
                      <td className="text-center text-nowrap">
                        {item.completedDate}
                      </td>
                      {activityType == ActivityTypes.Assignment && <td className="text-center">{item.retakeResults?.length ? item.retakeResults.length : 'N/A'}</td>}
                      {activityType != ActivityTypes.FlashCard && (
                        <td className="text-center">
                          <>
                            {item.assignmentOptions.disableLock ? (
                              <OverlayTrigger
                                key={`locked-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id={`tooltip-retakeResultsReport-${index}`}
                                    className="custom-tooltip">
                                    &apos;This assignment is locked until the student completes their
                                    retakes.&apos;
                                  </Tooltip>
                                }>
                                <FontAwesomeIcon
                                  disabled={true}
                                  icon={faLockKeyhole}
                                  className="disabledLock"
                                />
                              </OverlayTrigger>
                            ) : (
                              <OverlayTrigger
                                key={`locked-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id={`tooltip-retakeResultsReport-${index}`}
                                    className="custom-tooltip">
                                    {item.assignmentOptions.locked ? 'Locked' : 'Unlocked'}
                                  </Tooltip>
                                }>
                                <FontAwesomeIcon
                                  onClick={() => updateIndividualStudentLock(item.studentId)}
                                  icon={
                                    item.assignmentOptions.locked ? faLockKeyhole : faLockKeyholeOpen
                                  }
                                  className="lockUnlock h-25"
                                />
                              </OverlayTrigger>
                            )}
                          </>
                        </td>
                      )}
                      {activityType == ActivityTypes.FlashCard && <td className="text-center">{item.dateCompleted?.length ? 'Completed' : 'Incomplete'}</td>}
                      <td className='mt-2'>{generateAssignmentDetails(item.assignmentOptions, index, 3)}</td>
                      {activityType != ActivityTypes.FlashCard  && (
                        <>
                          <td>
                            <div className="d-flex flex-row action-btns gap-1">
                              <OverlayTrigger
                                key={`reponsesReport-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id={`tooltip-reponsesReport-${index}`}
                                    className="custom-tooltip">
                                    Responses
                                  </Tooltip>
                                }>
                                <button
                                  onClick={() =>
                                    item.dateStarted
                                      ?  navigate(
                                        `/responses/${item.assignmentId}/${activityType}/${item.studentId}`
                                      )
                                      : ''
                                  }>
                                  <FontAwesomeIcon icon={faMessagesQuestion} />
                                </button>
                              </OverlayTrigger>

                              <OverlayTrigger
                                key={`studentSessionReport-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id={`tooltip-studentSessionReport-${index}`}
                                    className="custom-tooltip">
                                    Student Session Report
                                  </Tooltip>
                                }>
                                <button
                                  onClick={() =>
                                    item.dateStarted
                                      ? reportNavigateHandler(
                                        item.studentId,
                                        item.assignmentId,
                                        item.className,
                                        scoreUnansweredAsZero
                                      )
                                      : ''
                                  }
                                >
                                  <FontAwesomeIcon icon={faChartArea} />
                                </button>
                              </OverlayTrigger>

                              <OverlayTrigger
                                key={`uploadedFilesOverlay-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id={`tooltip-uploadedFilesOverlay-${index}`}
                                    className="custom-tooltip">
                                    Student Uploaded Files
                                  </Tooltip>
                                }>
                                <button
                                  onClick={() => {
                                    studentFilesModalData.current = {
                                      files: item.uploadedFiles,
                                      studentName: `${item.studentFirstName} ${item.studentLastName}`
                                    };
                                    item.uploadedFiles.length > 0 ? setShowStudentFilesModal(true) : '';
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faPaperclip}
                                    className={item.uploadedFiles.length > 0 ? 'text-color-yellow' : ''}
                                    cursor={item.uploadedFiles.length > 0 ? 'pointer' : ''}
                                  />
                                </button>
                              </OverlayTrigger>
                              {item.retakeEnabled && (
                                <OverlayTrigger
                                  key={`retakeResultsReport-${index}`}
                                  placement="top"
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-retakeResultsReport-${index}`}
                                      className="custom-tooltip">
                                      Retakes Results
                                    </Tooltip>
                                  }>
                                  <button
                                    onClick={() => { handleRetakeResultsClick(item); }}>
                                    <FontAwesomeIcon icon={faRetweet}/>
                                  </button>
                                </OverlayTrigger>
                              )}
                            </div>
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </UiVirtualScroll>
      </div>

      <div className="d-flex floating-menu-contained floating-menu-sticky justify-content-center">
        <FloatingMenu floatingButtons={floatingMenuButtons} onClick={handleClick} />
      </div>
      {showRetakesModal && (
        <RetakesModal
          studentId={currentStudentResult.studentId}
          studentName={currentStudentResult.studentLastName + ' ' + currentStudentResult.studentFirstName}
          classId={currentStudentResult.classId}
          className={currentStudentResult.className}
          retryCreditId={retryCreditId}
          isOpen={showRetakesModal}
          onClose={() => {setShowRetakesModal(false), setCurrentStudentResult([]);}}
          accumulatedRetake={currentStudentResult.accumulatedRetake}
          accumulatedScorePercentage={currentStudentResult.accumulatedScorePercentage}
          originalAssignmentId={Id}
          calculateOriginalScore={(item,showPoints) => calculateOriginalScore(item,showPoints)}
        />
      )}

      <Modal
        show={showConfirmUnassignModal}
        onHide={() => setShowConfirmUnassignModal(false)}
        size="lg"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Unassign {ActivityUtils.getActivityName(activityType)}</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div
              style={{
                backgroundImage: `url(${ConfirmUnassign})`,
                backgroundRepeat: 'no-repeat',
                height: '120px',
                width: '140px'
              }}></div>

            <div style={{ fontSize: '1rem', fontWeight: '600' }}>
              Are you sure that you want to unassign the {ActivityUtils.getActivityName(activityType).toLowerCase()} from the checked students?
            </div>
            <div className="my-3 text-center">
              By unassigning from students who have started the {ActivityUtils.getActivityName(activityType).toLowerCase()}, you will no longer be
              able to view their results for this {ActivityUtils.getActivityName(activityType).toLowerCase()}.
            </div>

            <div className="d-flex flex-row justify-content-evenly w-50">
              <Button
                className="w-50"
                variant="castleGray"
                onClick={() => setShowConfirmUnassignModal(false)}>
                No
              </Button>
              <Button
                className="ms-3 w-50"
                variant="castleRed"
                onClick={() => handleUnassignStudents()}
                disabled={unassignStudentsResult.isLoading}>
                Yes
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showConfirmReviewModal}
        onHide={() => setShowConfirmReviewModal(false)}
        size="lg"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Confirm</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div className="my-3" style={{ fontSize: '1rem', fontWeight: '600' }}>
              Are you sure you want to set the original assignments and retakes to review?
            </div>

            <div className="d-flex flex-row justify-content-even w-50">
              <Button
                className="w-50"
                variant="castleGray"
                onClick={() => setShowConfirmReviewModal(false)}>
                No
              </Button>
              <Button
                className="ms-3 w-50"
                variant="castleRed"
                onClick={() => handleSetAssignmentToReview()}
                disabled={setAssignmentToReviewResults.isLoading}>
                Yes
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default AssignmentResults;
